<aside class="sidebar">

  <div class="brand">
    <img src="../../../assets/images/Augajo/augajoblanco.avif" alt="Augajo" class="brand-logo">

  </div>


  <div id="leftside-navigation">

    @for (menu of (sideMenuFacade.responseMenus$ | async); track menu) {
    <mat-accordion class="accordion">
      <mat-expansion-panel [expanded]="true" class="mat-expansion-panelP2">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span class="textSideHeader">{{ menu.Menu }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <mat-nav-list appAccordion class="fs2">
            @for (menuitem of menu?.hijos; track menuitem) {
            <a mat-list-item class="list" [routerLink]="menuitem.Url" [routerLinkActive]="['is-active']">
              <span class="list-content">
                <i class="{{ menuitem.Icono }} icon"></i>
                <span class="textSide">{{ menuitem.Menu }}</span>
              </span>
            </a>
            }
          </mat-nav-list>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
    }
  </div>

  <div class="sidebar-footer">
    <button class="footer-user" [matMenuTriggerFor]="menuUsuario">
      <div class="avatar">{{ usuario?.Usuario | slice: 0:2 }}</div>
      <div class="user-info">
        <div class="user-name">{{ usuario?.Usuario }}</div>
        <div class="user-role">{{ usuario?.TipoUsuario }}</div>
      </div>
      <mat-icon class="footer-chevron">expand_less</mat-icon>
    </button>

    <mat-menu #menuUsuario="matMenu" class="menu-perfil" xPosition="before" yPosition="above">
      <div class="perfil-header">
        <div class="perfil-avatar">{{ usuario?.Usuario | slice: 0:2 }}</div>
        <div class="perfil-info">
          <div class="perfil-nombre">{{ usuario?.Usuario }}</div>
          <div class="perfil-rol">{{ usuario?.TipoUsuario }}</div>
        </div>
      </div>
      <div class="perfil-divisor"></div>

      <button mat-menu-item class="perfil-item" [routerLink]="'/dashboard'">
        <mat-icon>home</mat-icon>
        <span>Inicio</span>
      </button>
      <button mat-menu-item class="perfil-item" (click)="cerrarSesion()">
        <mat-icon>logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </mat-menu>
  </div>

</aside>